import { observable, action, computed, configure, runInAction } from 'mobx';
import axios, { AxiosResponse } from 'axios';
import { createContext, MouseEvent } from 'react';
import { IProjectPhoto } from '../models/projectphoto';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { IPhotoUpload } from '../models/photoupload';
import { IProject } from '../models/project';
import { ITaskAssignment } from '../models/taskassignment';
import { ITechnicianSOR } from '../models/techniciansor';
import { IPhoto } from '../models/photo';

configure({enforceActions: 'always'});

class TechnicianProjectStore {
  @observable photouploadRegistry = new Map();
  @observable photouploadCount = new Map();
  @observable photoupload: IProjectPhoto | null = null;
  @observable technicianprojectRegistry = new Map();
  @observable technicianproject: IProject | null = null;
  @observable techniciansorRegistry = new Map();
  @observable techniciansor: ITechnicianSOR | null = null;
  @observable loadingInitial = false;
  @observable uploadingFile = false;
  @observable submitting = false;
  @observable target = '';
  @observable percentCompleted = '';

  claimedqtyUpdate = new Map();

  @computed get photouploadsByName() {
    return Array.from(this.photouploadRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get technicianprojectsByDate() {
    return Array.from(this.technicianprojectRegistry.values()).sort(
      (a, b) => Date.parse(a.jobStartDate) - Date.parse(b.jobStartDate)
    );
  }

  @computed get techniciansorsByCategory() {
    return Array.from(this.techniciansorRegistry.values()).sort(
      (a, b) => a.itemCategory.localeCompare(b.itemCategory));
  }

  @action loadPhotoUploads = async (projectId: string) => {
    this.loadingInitial = true;
    var previousName = '';
    var photoRequest = [''];
    this.photouploadRegistry.clear();

    try {
      const photouploads = await agent.PhotoUploads.list(projectId);
      runInAction('loading photo uploads', () => {
        photouploads.forEach(photoupload => {
          if (photoupload.name === previousName)
          {
            photoRequest.push(photoupload.request);
            this.photouploadRegistry.set(photoupload.name, {name: photoupload.name, request: photoRequest});
          }
          else
          {
            photoRequest.length = 0;
            previousName = photoupload.name;
            photoRequest.push(photoupload.request);
            this.photouploadRegistry.set(photoupload.name, {name: photoupload.name, request: photoRequest});
            this.photouploadCount.set(photoupload.name, photoupload.count);
          }
        });
        this.loadingInitial = false;
      })

    } catch (error) {
      runInAction('load photo uploads error', () => {
        this.loadingInitial = false;
      })
      toast.error('load photo uploads error');
    }
  };

  @action updateCount = async (photoreturn : IPhoto, name : string) => {
      this.photouploadCount.set(name, photoreturn.count);
  };

  @action loadTechnicianProjects = async () => {
     this.loadingInitial = true;
    try {
      const projects = await agent.TaskAssignments.select();
      this.technicianprojectRegistry.clear();
      runInAction('loading technician projects', () => {
        projects.forEach(project => {
          this.technicianprojectRegistry.set(project.id, project);
        });
         this.loadingInitial = false;
      })
  
    } catch (error) {
      runInAction('load technician projects error', () => {
         this.loadingInitial = false;
      })
      toast.error('load technician project error');
    }
  };

  @action loadProject = async (id: string) => {
    let project = this.getProject(id);
    if (project) {
      this.technicianproject = project;
    } else {
      this.loadingInitial = true;
      try {
        project = await agent.Projects.details(id);
        runInAction('getting project',() => {
          this.technicianproject = project;
          this.loadingInitial = false;
        })
      } catch (error) {
        runInAction('get project error', () => {
          this.loadingInitial = false;
        })
        toast.error('get project error');
        console.log(error);
      }
    }
  };

  @action loadTechnicianSORs = async (projectId: string) => {
    // this.loadingInitial = true;
    try {
      const techniciansors = await agent.TechnicianProjects.list(projectId);
      this.techniciansorRegistry.clear();
      runInAction('loading tasks', () => {
        techniciansors.forEach(techniciansor => {
          this.techniciansorRegistry.set(techniciansor.id, techniciansor);
        });
        // this.loadingInitial = false;
      })
  
    } catch (error) {
      runInAction('load tasks error', () => {
        // this.loadingInitial = false;
      })
      toast.error('load tasks error');
    }
  }

  @action changeClaimedQty = async (id: string, value: string) => {
    var techniciansor = this.techniciansorRegistry.get(id);
    techniciansor.claimedQty = value;
    this.techniciansorRegistry.set(id, techniciansor);
    this.claimedqtyUpdate.set(id, {'id': id, 'claimedQty' : techniciansor.claimedQty});
  }

  @action updateClaimedQty = async () => {
    let claimedqtyupdate = Array.from(this.claimedqtyUpdate.values());
    if (claimedqtyupdate.length === 0) return;
    this.submitting = true;
    try {
      await agent.TechnicianProjects.update(claimedqtyupdate);
      runInAction('updating claimed quantity', () => {
        this.claimedqtyUpdate.clear();
        this.submitting = false;
      })
    } catch (error) {
      runInAction('update claimed quantity error', () => {
        this.submitting = false;
      })
      toast.error('update claimed quantity error');
      console.log(error);
    }
  };

 getProject = (id: string) => {
    return this.technicianprojectRegistry.get(Number(id));
  }

  
}

export default createContext(new TechnicianProjectStore());
